import {
    IconBackArrowLeft,
    IconChevronRightSmall,
    IconMobileBank,
    IconSearch,
} from '@holbonkit/icons'
import {
    BottomSheet,
    BottomSheetBody,
    BottomSheetClose,
    BottomSheetContent,
    BottomSheetHeader,
    BottomSheetTitle,
    BottomSheetTrigger,
    Button,
    Input,
    Text,
} from '@holbonkit/ui'

import styles from './sbp-bottom-sheet.module.scss'

export const SbpBottomSheet = () => {
    return (
        <BottomSheet>
            <BottomSheetTrigger>
                <Button
                    className={styles['sbp__button']}
                    endIcon={<IconChevronRightSmall color='var(--text-and-icon-secondary)' />}
                    size='lg'
                    startIcon={<IconMobileBank />}
                    type='button'
                    variant='secondary'
                >
                    <Text className={styles['sbp__button--text']} variant='body-m-16-medium'>
                        Выберите банк
                    </Text>
                </Button>
            </BottomSheetTrigger>
            <BottomSheetContent fullscreen showCloseButton={false}>
                <BottomSheetHeader className={styles['bottom-sheet__header']}>
                    <BottomSheetTitle>Выберите банк</BottomSheetTitle>
                    <BottomSheetClose>
                        <button
                            className={styles['bottom-sheet__header-back']}
                            data-test-id='sbp-bottom-sheet__back'
                            type='button'
                        >
                            <IconBackArrowLeft color='var(--text-and-icon-primary)' size={24} />
                        </button>
                    </BottomSheetClose>
                </BottomSheetHeader>
                <BottomSheetBody>
                    <Input label='Поиск банка' startIcon={<IconSearch />} />
                    <Text variant='body-m-16-medium'>
                        Очень много банков, которые можно выбрать с пагинацией
                    </Text>
                </BottomSheetBody>
            </BottomSheetContent>
        </BottomSheet>
    )
}
